export const getStudent = state => state.applicant.student;

export const getIsLoading = state => state.applicant.isLoading;

export const getError = state => state.applicant.error;

export const getIsSaving = state => state.applicant.isSaving;

export const getApplicantEmail = state => state.applicant.email;
